import { useLocalStorage } from "@ugitgud/legos/hooks/useLocalStorage";
import { isAfter, subHours } from "date-fns";
import { useLayoutEffect, useState } from "react";

export function useBanner(ctaId: string) {
  const [bannerClosed, setBannerClosed] = useState(true);
  const [bannerDismissedDate, setBannerDismissedDate] = useLocalStorage<{ dismissedDate?: string }>(`ugg-cta-${ctaId}`, {
    dismissedDate: undefined,
  });
  useLayoutEffect(() => {
    setBannerClosed(
      !!bannerDismissedDate.dismissedDate && isAfter(new Date(bannerDismissedDate.dismissedDate), subHours(new Date(), 1)),
    );
  }, [setBannerClosed, bannerDismissedDate.dismissedDate]);

  const setBannerOpen = (value: boolean) => {
    if (!value) {
      setBannerDismissedDate({ dismissedDate: new Date().toISOString() });
    }
    setBannerClosed(!value);
  };

  return {
    open: !bannerClosed,
    dismissedDate: bannerDismissedDate.dismissedDate,
    setBannerOpen,
  };
}
